const isProduction = window.location.hostname === 'app.pearler.ai';

export const log = (...args: string[]): void => {
    if (!isProduction) {
        console.log(...args);
    }
};
